<app-header></app-header>
<div class="content">
  <div class="form-recharge">
    <form (submit)="submit()" [formGroup]="form">
      <input name="productId" type="hidden" value={productId}/>
      <input name="productName" type="hidden" value={productName}/>

      <div class="main-title dashboard-title"><span>Dane do założenia konta w systemie</span></div>
      <div class="small75 progress-path">
        Wybór karty > <b>Rejestracja w systemie</b> > Płatność
      </div>
      <div class="description">
      <span class="body small75">
          Wypełnij poniższy formularz aby założyć konto w serwisie.
          Jest ono niezbędne aby móc później monitorować zużycie, doładować kartę, przedłużyć jej ważność
          czy podejrzeć biling.
          <p>
              Aby móc założyć konto należy posiadać minimum jedną kartę SIM wydaną przez SatPhoneRecharge.com.
          </p>
      </span>
      </div>
      <div class="recharge-options">
        <div class="title">
          Wybrany plan taryfowy: <b><span>{{ form.value.productName }}</span></b>
        </div>
        <br/>
        <label htmlFor="username">imię i nazwisko</label>
        <input formControlName="username" id="username" maxLength="150" name="username" placeholder="np. Jan Kowalski"
               type="text"/><br/>
        <label htmlFor="company">nazwa firmy</label>
        <input formControlName="company" id="company" maxLength="150" name="company" placeholder="" type="text"/><br/>
        <label htmlFor="nip">NIP</label>
        <input formControlName="nip" id="nip" maxLength="150" name="nip" placeholder="" type="text"/><br/>
        <label htmlFor="phone">telefon</label>
        <input formControlName="phone" id="phone" maxLength="30" minlength="9" name="phone" type="text"/>
        <br/>

        <hr/>
        <label htmlFor="email">e-mail (login)</label>
        <input formControlName="email" id="email" maxLength="150" name="email" placeholder="np. jan.kowalski@poczta.pl"
               type="text"/><br/>
        <br/>
        <label htmlFor="password">hasło</label>
        <input formControlName="password" id="password" maxLength="150" name="password" type="password"/><br/>
        <label htmlFor="passwordRepeat">powtórz hasło</label>
        <input formControlName="passwordRepeat" id="password" maxLength="150" name="passwordRepeat"
               type="password"/><br/>
        <p class="small75">
          Na podany adres zostanie wysłane jednorazowe hasło, <br/>
          które trzeba będzie zmienić przy pierwszym logowaniu
        </p>
        <hr/>

        <label htmlFor="street">ulica</label>
        <input formControlName="street" id="street" maxLength="150" name="street"
               placeholder="ulica wraz z numerem lokalu"
               type="text"/><br/>
        <label htmlFor="zip">kod pocztowy</label>
        <input formControlName="zip" id="zip" maxLength="150" name="zip" placeholder="" type="text"/><br/>
        <label htmlFor="city">miasto</label>
        <input formControlName="city" id="city" maxLength="150" name="city" placeholder="" type="text"/><br/>
        <input formControlName="country" id="country" name="country" type="hidden"/>
        <hr/>
        <div class="onerow">
          <label htmlFor="confirmation">Przeczytałem <a href="/regulamin" target="_blank">regulamin serwisu</a> i
            chcę
            założyć konto</label>
          <input formControlName="confirmation" id="confirmation" type="checkbox"/>
        </div>
        <div class="buttons">
          <button (click)="resetToHome()" type="reset">Wróć</button>
          <button [disabled]="!form.valid || !validateForm()" id="submitbtn" type="submit">Przejdź do płatności</button>
        </div>

      </div>
    </form>
    <footer class="content-footer">
      <img alt="logo" src="assets/parp-logo.jpg">
    </footer>
  </div>
</div>
